"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePlaceholder = exports.serializePlaceholder = void 0;
const serializePlaceholder = (type) => {
    return `Field ${type || "unknown"} not supported.`;
};
exports.serializePlaceholder = serializePlaceholder;
const validatePlaceholder = (item) => {
    if (!item.required) {
        return { valid: true };
    }
    else {
        return { valid: false, error: { message: "Please update your app." } };
    }
};
exports.validatePlaceholder = validatePlaceholder;
//# sourceMappingURL=placeholder.js.map